import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { fetchOne } from "../api";
import { Loader } from "../components/Shared";
import { NewsMedia } from "../components/NewsMedia";

const fmtDate = (d) => { try { return new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); } catch { return ""; } };

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { fetchOne("news", id).then(setN).catch(() => setN(false)); }, [id]);

  if (n === null) return <Loader />;
  if (n === false) return <div className="pt-40 px-6 text-center min-h-screen"><p className="text-zinc-400">Article not found.</p></div>;

  return (
    <article data-testid="news-detail-page" className="pt-28">
      <div className="relative h-[45vh] min-h-[320px]">
        <NewsMedia src={n.detail_image || n.image} poster={n.poster} alt={n.title} className="w-full h-full object-cover" style={{ objectPosition: n.hero_pos || (n.detail_image ? "center" : "center 25%") }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent" />
      </div>
      <div className="px-6 md:px-12 lg:px-20 -mt-24 relative z-10 max-w-3xl mx-auto pb-24">
        <div className="font-mono text-xs uppercase tracking-widest text-brand">{n.category} · {fmtDate(n.date)} · {n.author}</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase tracking-tight leading-none mt-3">{n.title}</h1>
        <p className="text-zinc-300 text-xl leading-relaxed mt-8 font-light">{n.excerpt}</p>
        <div className="text-zinc-400 leading-relaxed mt-6 whitespace-pre-line">{n.body}</div>

        <div className="mt-14 pt-10 border-t border-zinc-800">
          <Link
            to="/news"
            data-testid="back-to-news"
            className="inline-flex items-center gap-3 bg-brand hover:bg-brand-hi text-black font-display text-xl uppercase tracking-wide px-7 py-4 transition-colors"
          >
            <ArrowLeft size={20} /> Back to News
          </Link>
        </div>
      </div>
    </article>
  );
}
